import { createReducer, on } from '@ngrx/store';

import { StateUtils } from '@state/state-utils';
import * as Actions from './service-provider.actions';
import {
    ServiceProviderState,
    initialServiceProviderState,
} from './service-provider.state';

const serviceProviderReducer = createReducer<ServiceProviderState>(
  initialServiceProviderState,

  on(Actions.fetchServiceProvidersSuccess, (state, { serviceProviders }) => ({
    ...state,
    serviceProviders,
    fetchedAt: new Date(),
  })),
  on(Actions.fetchServiceProviderByIdSuccess, (state, { serviceProvider }) => ({
    ...state,
    serviceProviders: StateUtils.combineState(state.serviceProviders, serviceProvider),
    fetchedAt: new Date(),
  })),
  on(
    Actions.updateServiceProviderSuccess,
    Actions.updateServiceProviderImageSuccess,
    (state, { serviceProvider }) => ({
      ...state,
      serviceProviders: StateUtils.combineState(state.serviceProviders, serviceProvider),
    })
  ),
  on(
    Actions.fetchCurrentServiceProviderAdminsSuccess,
    (state, { serviceProviderId, admins }) => ({
      ...state,
      serviceProviders: state.serviceProviders.map((sp) => {
        if (sp.id === serviceProviderId) return { ...sp, admins };
        return sp;
      }),
    })
  ),
  on(Actions.addServiceProviderAdminSuccess, (state, { serviceProvider, admin }) => ({
    ...state,
    serviceProviders: state.serviceProviders.map((x) => {
      if (x.id === serviceProvider.id) {
        return { ...x, admins: [...(x.admins ?? []), admin] };
      }
      return x;
    }),
  })),
  on(
    Actions.fetchServiceProvidersFailed,
    Actions.fetchServiceProviderByIdFailed,
    Actions.fetchCurrentServiceProviderAdminsFailed,
    (state, { error }) => ({
      ...state,
      fetchedAt: new Date(),
    })
  )
);

export { serviceProviderReducer };


